import { ProgressBar } from "primereact/progressbar";

const ProgressBarCustom = ({ value, total }) => {
    const percentage = (value / total) * 100;
    return <ProgressBar value={percentage} style={{ height: "12px" }} />;
};

export default ProgressBarCustom;
